<ui-page-container size="medium">
  <mat-card>
    <mat-card-title>
      {{ (entityId ? 'Modifica collezione' : 'Nuova collezione') | translate }}
    </mat-card-title>
    <mat-card-content>
      <mat-tab-group animationDuration="0ms">
        <mat-tab [label]="'Generali' | translate">
          <form
            *ngIf="entityForm"
            [formGroup]="entityForm"
            (ngSubmit)="dispatchAction(entityForm)">
            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="text"
                name="titolo"
                matInput
                formControlName="titolo"
                [placeholder]="'Titolo' | translate">
            </mat-form-field>
            <mat-error
              class="message-error"
              *ngIf="entityControls?.titolo?.touched && entityControls?.titolo?.hasError('required')">
              {{ 'Titolo obbligatorio' | translate }}
            </mat-error>

            <mat-form-field class="input-expanse">
              <input
                class="input-expanse"
                type="text"
                name="descrizione"
                matInput
                formControlName="descrizione"
                [placeholder]="'Descrizione' | translate">
            </mat-form-field>

            <div class="collection-actions">
              <button
                mat-raised-button
                color="primary"
                type="submit">
                {{ (entityId ? 'Modifica' : 'Crea') | translate }}
              </button>
            </div>
          </form>
        </mat-tab>
        <mat-tab
          *ngIf="mode === 'edit'"
          [label]="'Elementi' | translate">
          <app-collection-items [collection]="entityForm?.value"></app-collection-items>
        </mat-tab>
        <mat-tab *ngIf="mode === 'edit'"
                 [label]="'Elementi ordinabili' | translate"
        >

          <app-collection-elements [collection]="entityForm?.value"></app-collection-elements>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</ui-page-container>
